var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "page-title" }, [_vm._v(" Financial Settings ")]),
    _c("div", { staticClass: "page-container" }, [
      _c(
        "div",
        {
          staticClass: "filter-right-container",
          staticStyle: { height: "24px" },
        },
        [
          _c("div", { staticClass: "filter-container-tag" }, [
            _vm._v(" " + _vm._s(_vm.$t("components.banks")) + " "),
          ]),
        ]
      ),
      _c(
        "div",
        [
          _c(
            "el-tabs",
            {
              attrs: { type: "card" },
              model: {
                value: _vm.activeName,
                callback: function ($$v) {
                  _vm.activeName = $$v
                },
                expression: "activeName",
              },
            },
            _vm._l(_vm.componentConfig, function (item, index) {
              return _c("el-tab-pane", {
                key: index,
                attrs: { label: item.label, name: item.compName },
              })
            }),
            1
          ),
          _c(_vm.activeName, {
            key: _vm.activeName,
            tag: "component",
            on: { changeComponent: _vm.changeComponent },
          }),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }